import React from 'react'
import '../assets/css/fa.css'

export default (props) => {
	const { service, index } = props
	return(
        <div className="col-md-4" id={index} key={index}>
            <div className="box" key={index+1}>
                <div className={service.bgHover}>
                    <div className="icon"> 
                    	<div style={{backgroundColor: service.color, width: 100+'px', height: 100+'px'}} className="rotate" width="100" height="100">De-La-Chef</div>
                    </div>
                    <h4 style={{textDecoration: 'underline'}} key={index+4}>{service.title}</h4>
                    <p className={service.cardDescription} key={index+5}>{service.description}</p>
                    <br />
                    <span className={service.learnMore}  key={index+6}>
			      		Learn More
			    	</span>
                </div>
            </div>
        </div>
	)
}